import { CopyIcon } from "@xola/icons";
import { flash } from "@xola/ui-kit";
import React from "react";
import { SecondaryButton } from "../../../Common/SecondaryButton";
import { ButtonCodeHeading } from "../ButtonCodeHeading";
import { xolaUri } from "@/api/xolaUri";

export const StepOneCommonSiteCode = () => {
    const xolaCheckoutUrl = xolaUri;
    const includeCode = `<script type="text/javascript"> (function() { var co=document.createElement("script");
     co.type="text/javascript"; co.async=true; co.src="${xolaCheckoutUrl}/checkout.js";
     var s=document.getElementsByTagName("script")[0]; s.parentNode.insertBefore(co, s); })(); </script>`;

    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText(includeCode);
        flash.success("Code copied to clipboard");
    };

    return (
        <div className="flex h-full flex-row items-start space-x-2 py-8">
            <ButtonCodeHeading number={1}>Paste this code into your site&apos;s header or footer</ButtonCodeHeading>

            <div className="h-26 flex items-center rounded border border-gray-light p-3 text-gray-darker">
                <div className="font-mono">{includeCode}</div>
                <SecondaryButton title="Click to copy" size="small" onClick={handleCopyToClipboard}>
                    <CopyIcon />
                </SecondaryButton>
            </div>
        </div>
    );
};
